import styled from 'styled-components'

import ReactGA from 'react-ga4'
import LeftBar from '../home/components/leftBar'
import DocumentAnalyzer from './DocumentAnalyzer'
import SystemStatusBanner from '../../globalComponents/SystemStatusBanner'

const Page = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden !important;
`

const Content = styled.div`
    display: flex;
    flex: 1;
    overflow: hidden;
`

export default function RED() {
    ReactGA.send({
        hitType: 'pageview',
        page: '/analisador',
        title: 'RED',
    })

    return (
        <Page>
            <SystemStatusBanner />
            <Content>
                <LeftBar />
                <DocumentAnalyzer />
            </Content>
        </Page>
    )
}
